import { render, staticRenderFns } from "./CampaignsMembers.vue?vue&type=template&id=993ea8ec&"
import script from "./CampaignsMembers.vue?vue&type=script&lang=js&"
export * from "./CampaignsMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports